<template>
  <div>
    <div class="footer pt-5">
      <b-link :to="{name: 'Home'}">⇽ zurück</b-link>
      <b-link :to="{name: 'pages-impressum'}">Impressum</b-link>
      <b-link :to="{name: 'pages-privacy'}">Datenschutz</b-link>
      <b-link :to="{name: 'pages-about'}">Über uns</b-link>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>